export default __webpack_public_path__ + "audioc58db7.png";